import { AfterContentInit, Component, OnInit } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { UserProfileEntity } from 'src/shared/model/UserProfile';

import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { AbstractDataProvider } from '../AbstractDataProvider';
import { Subject } from 'rxjs';
import { DynamicModalService } from '../ui-components/dynamic-modals/dynamic-modal.service';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import {getErrorMessageText} from '../helper';


@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})

export class ChangePasswordComponent implements OnInit, AfterContentInit {
  userProfile: UserProfileEntity = new UserProfileEntity();

  display = false;
  alertMessage: string;
  logoImageUrl: string;


  showHeader = true;
  public subjectOnClose: Subject<any>;

  constructor(public rest: RestService,
              private dynamicModalService: DynamicModalService,
              private authService: AuthServiceCustom,
              private ngxService: NgxUiLoaderService,
              private abstractDataProvider: AbstractDataProvider,
              private dictionaryPipe: DictionaryPipe) {
  }

  ngOnInit() {
    // this.authService.accessTokenRemovedSubj.next(true);
  }

  ngAfterContentInit() {
    if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
      this.showHeader = false;
    }
  }

  submit() {
    if (!this.userProfile.OldPassword) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_OLD_PASSWORD');
      return;
    }
    if (!this.userProfile.Password) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_NEW_PASSWORD');
      return;
    }
    if (!this.userProfile.ConfirmPassword) {
      this.display = true;
      this.alertMessage =this.dictionaryPipe.transform('ENTER_CONFIRM_PASSWORD')  ;
      return;
    }
    if (this.userProfile.Password != this.userProfile.ConfirmPassword) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('NEW_PASSWORD_AND_CONFIRM_DONT_MATCH');
      return;
    }

    this.abstractDataProvider.postData(this.userProfile, 'api/Accounts/SubmitResetPassword').subscribe(
      posts => {
          this.close();
      },
      error => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      }
    );


  }

  getConfigurationDataOfLoggedInUser() {
    this.abstractDataProvider.getData('api/Accounts/GetAlreadySetSecurityQuestion').subscribe(
      (posts) => {
          this.dynamicModalService.subject.next(null);
          if (posts.SetUpSecurityQuestion) {
            this.close();
            // Check if Security question fields are blank,  then navigate to set-security-question
            this.authService.navigateToUrl('set-security-question', {
              from: 'change-password',
              returnUrl: 'home',
              Mode: 2,
              userId: this.userProfile.UserId
            });
        } else {
          this.close();
        }
      },
      (error) => {
        this.close();
      }
    );
  }

  cancel() {
    this.close();
  }

  close() {
    if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
      this.subjectOnClose.next(null);
      this.dynamicModalService.subject.next(null);
    } else {
      this.authService.navigateToUrl('home');
    }
  }

  onConfirm() {
    this.display = false;
  }
}
